/**
 * Handles the click or keydown event on the hamburger button.
 * Toggles the navigation menu and body scroll lock.
 *
 * @param {Event} e - The event object (click or keydown).
 */
function handleHamburger(e) {
  e.preventDefault();
  document.querySelector('.section-header').classList.toggle('nav-active');
  document.body.classList.toggle('lock-scroll');
}

/**
 * Handles the click or keydown event on a parent anchor in mobile view.
 * Toggles the sub-navigation for the clicked parent item.
 *
 * @param {Event} e - The event object (click or keydown).
 */
function handleParentAnchorClick(e) {
  if (
    window.getComputedStyle(document.querySelector('.hamburger')).display ===
    'block'
  ) {
    e.preventDefault();
    const parent = e.target.closest('.item-parent');
    document.querySelectorAll('.sub-nav-active').forEach(function (el) {
      el.classList.remove('sub-nav-active');
    });
    parent.classList.add('sub-nav-active');
  }
}

/**
 * Handles the click or keydown event on a back anchor button.
 * Collapses the sub-navigation by removing the `sub-nav-active` class.
 *
 * @param {Event} e - The event object (click or keydown).
 */
function handleBackAnchorClick(e) {
  e.preventDefault();
  // Find the closest parent that has the `sub-nav-active` class and remove it
  const subNavParent = e.target.closest('.sub-nav-active');
  if (subNavParent) {
    subNavParent.classList.remove('sub-nav-active');
  }
}

// Event listeners for hamburger menu toggle
document.querySelectorAll('.hamburger').forEach(function (hamburger) {
  hamburger.addEventListener('click', handleHamburger);
  hamburger.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      handleHamburger(e);
    }
  });
});

// Event listeners for navigation parent items
document.querySelectorAll('.nav > .item-parent').forEach(function (parent) {
  parent.addEventListener('mouseenter', function () {
    parent.querySelector('.parent-anchor').classList.add('open');
    document.querySelector('.header').classList.add('open');
    document.body.classList.add('overlay-open');
  });

  parent.addEventListener('mouseleave', function () {
    parent.querySelector('.parent-anchor').classList.remove('open');
    document.querySelector('.header').classList.remove('open');
    document.body.classList.remove('overlay-open');
  });

  parent.addEventListener('focusin', function () {
    parent.querySelector('.parent-anchor').classList.add('open');
    parent.querySelector('.sub-nav').setAttribute('aria-hidden', 'false');
    document.querySelector('.header').classList.add('open');
    document.body.classList.add('overlay-open');
  });

  parent.addEventListener('focusout', function (e) {
    // Ensure this only runs when focus fully leaves the parent
    if (!parent.contains(e.relatedTarget)) {
      parent.querySelector('.parent-anchor').classList.remove('open');
      parent.querySelector('.sub-nav').setAttribute('aria-hidden', 'true');
      document.querySelector('.header').classList.remove('open');
      document.body.classList.remove('overlay-open');
    }
  });
});

// Event listeners for parent anchors in mobile view
document.querySelectorAll('.parent-anchor').forEach(function (anchor) {
  anchor.addEventListener('click', handleParentAnchorClick);
  anchor.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      handleParentAnchorClick(e);
    }
  });
});

// Event listeners for back anchor buttons
document.querySelectorAll('.back-anchor').forEach(function (backAnchor) {
  backAnchor.addEventListener('click', handleBackAnchorClick);
  backAnchor.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      handleBackAnchorClick(e);
    }
  });
});
